import React from "react";
import styled from "styled-components";

// Images
import Vorher1 from "../../assets/img/vorher1.png";
import Nachher1 from "../../assets/img/nachher1.png";
import Vorher2 from "../../assets/img/vorher2.png";
import Nachher2 from "../../assets/img/nachher2.png";
import Repair from "../../assets/img/repair.png";
import Restore from "../../assets/img/restore.png";

export default function Blog() {
  return (
      <Wrapper id="blog" className="lightBg">
        <div >
          <div className="container">
            <HeaderInfo>
              <h1 className="font36 extraBold">Teppichreparaturwerkstätten</h1>
            </HeaderInfo>
            <TextSection>
              <p className="font18">
                Unsere hauseigene Teppichreparaturwerkstatt ist spezialisiert auf die fachgerechte Instandsetzung und Restaurierung
                von handgeknüpften Teppichen – mit Liebe zum Detail und dem Wissen aus über 28 Jahren Erfahrung.
              </p>
              <p className="font18">
                Wir führen professionelle Reparaturen an <strong>Kanten</strong> und <strong>Fransen</strong> durch,
                setzen <strong>Lederbänder</strong> ein, beheben <strong>Falten (Spannprobleme)</strong>, behandeln <strong>Mottenstellen</strong> sowie <strong>Brand- und Wasserschäden</strong> und übernehmen auch <strong>Nachknüpfungen</strong> und <strong>Teppichverkleinerungen</strong>.
              </p>
            </TextSection>

            <HeaderInfo>
              <p className="font18">
                <strong>Fransen:</strong> Die Fransen waren offen und ungesichert – das Flormaterial abgetreten, sodass sich Knoten lösten und Teile der Bordüre verloren gingen.
                Wird so ein Zustand nicht rechtzeitig behoben, kann sich der Schaden schnell vergrößern.
              </p>
                <p className="font18">Durch eine professionelle Fransenreparatur lässt sich der Teppich nicht nur optisch aufwerten, sondern auch dauerhaft stabilisieren – damit er Ihnen noch viele Jahre erhalten bleibt.
              </p>
            </HeaderInfo>
            <ImageRow className="flexCenter">
              <ImageWrapper>
                <p>Vorher</p>
                <img src={Vorher1} alt="Vorher 1" />
              </ImageWrapper>
              <ImageWrapper>
                <p>Nachher</p>
                <img src={Nachher1} alt="Nachher 1" />
              </ImageWrapper>
            </ImageRow>
            <HeaderInfo>
              <p className="font18">
                <strong>Kanten:</strong>  Die Längskanten waren beschädigt – das Grundgewebe lag frei und einzelne Fäden hatten sich gelöst.
                Unbehandelt kann sich der Schaden weiter ausbreiten und die Stabilität des Teppichs gefährden.
              </p>
              <p className="font18">
                Durch eine fachgerechte Reparatur wurden die Kanten verstärkt und das ursprüngliche Muster sorgfältig wiederhergestellt – für mehr Haltbarkeit und ein gepflegtes Erscheinungsbild.
              </p>
            </HeaderInfo>
            <ImageRow className="flexCenter">
              <ImageWrapper>
                <p>Vorher</p>
                <img src={Vorher2} alt="Vorher 2" />
              </ImageWrapper>
              <ImageWrapper>
                <p>Nachher</p>
                <img src={Nachher2} alt="Nachher 2" />
              </ImageWrapper>
            </ImageRow>
            <RepairSection className="flexCenter">
              <RepairWrapper>
                <p>Wir reparieren</p>
                <Img src={Repair} alt="Wir reparieren" />
              </RepairWrapper>
              <RepairWrapper>
                <p>Und restaurieren</p>
                <Img src={Restore} alt="Und restaurieren" />
              </RepairWrapper>
            </RepairSection>
            <TextSection>
              <p className="font18">
                In den letzten Jahrzehnten haben wir mit Fleiß, handwerklicher Präzision und ehrlichem Service
                das Vertrauen tausender zufriedener Kunden gewonnen.
              </p>
            </TextSection>
          </div>
        </div>
      </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 60px;

`;

const HeaderInfo = styled.div`
  margin-bottom: 5px;

  @media (max-width: 860px) {
    //text-align: center;
  }
  h1 {
    margin-bottom: 5px;
    font-weight: bold;
    text-align: center;

  }
`;

const ImageRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px;
  @media (max-width: 860px) {
    flex-direction: column;
    align-items: center;
  }
`;

const ImageWrapper = styled.div`
  width: 48%;
  text-align: center;
  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  }
  p {
    font-weight: bold;
  }
`;

const RepairSection = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 860px) {
    flex-direction: column;
    align-items: center;
  }
`;

const RepairWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 20px;
  img {
    width: 60%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  }
  p {
    font-weight: bold;
  }
`;
const Img = styled.img`
  //width: 30%;

`;
const TextSection = styled.div`
  margin: 20px 0;
  text-align: center;

  p {
    line-height: 1.5;
  }
`;
